import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";

class ViewPixelogProfile extends Component {

  //프로필 이미지 로드
  // profileOnload = () =>{
  //   const { profileKey } = this.props;
  //   window.pskl.website.createAnimatedPreviewforVIEW(profileKey, 1, event, false)
  // }

	render(){
		const { profileUrl } = this.props;
		return (
			<Fragment>
	          {
                  profileUrl !== null
	              ? 
	              (
	              	<div>
	                    <img 
	                      className="img-follow rounded-circle" 
	                      src={profileUrl}
	                    />
                    </div>                  
	              )
	              :
	              (
	              	<div>
		                <img 
		                  className="img-follow-null rounded-circle"
		                  src="/img/pixelog-profile.png" 
		                />
	                </div>
	              )
	          }
	          </Fragment>
			
		);//return
	}//render
}

export default ViewPixelogProfile;
